<template>
  <div class="releases-profit-cost-modern">
    <!-- Modal Period Filter -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="period"
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-calendar-alt mr-2"></i>
          Filtrar por Período
        </div>
      </template>

      <div class="modal-content-modern">
        <div class="form-grid">
          <div class="form-group">
            <label class="form-label">Data Inicial</label>
            <input v-model="start_date" type="date" class="modern-form-input" />
          </div>

          <div class="form-group">
            <label class="form-label">Data Final</label>
            <input v-model="end_date" type="date" class="modern-form-input" />
          </div>
        </div>

        <ErrorsMessages :errors="errors" />

        <div class="modal-actions">
          <v-btn class="btn-cancel-modern" @click="handleCancelFilterByPeriod">
            <i class="fas fa-times mr-2"></i>
            Cancelar
          </v-btn>
          <v-btn
            @click="handleFilterByPeriod"
            :disabled="loading"
            class="btn-filter-modern"
          >
            <i class="fas fa-filter mr-2"></i>
            {{ loading ? "Carregando..." : "Filtrar" }}
          </v-btn>
        </div>
      </div>
    </b-modal>

    <!-- Modal Account Filter -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      id="account"
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-university mr-2"></i>
          Filtrar por Contas
        </div>
      </template>

      <div class="modal-content-modern">
        <div class="accounts-section">
          <div class="custom-control custom-checkbox select-all-checkbox">
            <input
              v-model="all_account"
              type="checkbox"
              class="custom-control-input"
              id="all-account"
              @change="handleAllAccount($event.target.checked)"
            />
            <label class="custom-control-label" for="all-account"
              >Selecionar Todas</label
            >
          </div>

          <b-form-group class="accounts-list">
            <b-form-checkbox
              v-for="account in finance_configuration_account"
              v-model="account_ids"
              :key="account.id"
              :value="account.id"
              @input="handleAccount"
              class="account-checkbox"
            >
              {{ account.account_nickname }}
            </b-form-checkbox>
          </b-form-group>
        </div>

        <ErrorsMessages :errors="errors" />

        <div class="modal-actions">
          <v-btn class="btn-cancel-modern" @click="$bvModal.hide('account')">
            <i class="fas fa-times mr-2"></i>
            Cancelar
          </v-btn>
          <v-btn @click="get" :disabled="loading" class="btn-filter-modern">
            <i class="fas fa-filter mr-2"></i>
            {{ loading ? "Carregando..." : "Filtrar" }}
          </v-btn>
        </div>
      </div>
    </b-modal>

    <!-- Modal More Filters -->
    <b-modal
      size="xl"
      no-close-on-backdrop
      hide-footer
      id="filters"
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-sliders-h mr-2"></i>
          Mais Filtros
        </div>
      </template>

      <div class="modal-content-modern">
        <Filters
          :users="users"
          :providers="providers"
          :finance_client="finance_client"
          :finance_configuration_document_types="
            finance_configuration_document_types
          "
          :finance_configuration_payment_methods="
            finance_configuration_payment_methods
          "
          :finance_configuration_category="finance_configuration_category"
          :finance_configuration_category_parents="
            finance_configuration_category_parents
          "
          :finance_configuration_profit_cost_center="
            finance_configuration_profit_cost_center
          "
          :finance_configuration_tag="finance_configuration_tag"
          :cost_types="cost_types"
          :cost_appropriations="cost_appropriations"
          :filters="{
            types_of_entries_ids,
            users_ids,
            provider_ids,
            finance_client_ids,
            finance_configuration_document_types_ids,
            finance_configuration_payment_methods_ids,
            finance_configuration_category_ids,
            finance_configuration_profit_cost_center_ids,
            finance_configuration_tag_ids,
            cost_types_ids,
            cost_appropriations_ids,
          }"
          @success="handleSuccessFilters"
          @cancel="$bvModal.hide('filters')"
        />
      </div>
    </b-modal>

    <!-- Header Section -->
    <div class="page-header">
      <div class="header-content">
        <div class="title-section">
          <h1 class="page-title">
            <i class="fas fa-chart-pie title-icon"></i>
            Lançamentos por Centros de Custo/Lucro
          </h1>
          <p class="page-subtitle">Análise detalhada por centro de resultado</p>
        </div>

        <div class="actions-section">
          <v-btn
            :disabled="loading"
            @click="$bvModal.show('account')"
            class="btn-filter-header"
          >
            <i class="fas fa-university mr-2"></i>
            {{ loading ? "..." : "Contas" }}
          </v-btn>

          <v-btn
            :disabled="loading"
            @click="$bvModal.show('filters')"
            class="btn-filter-header"
          >
            <i class="fas fa-sliders-h mr-2"></i>
            {{ loading ? "..." : "Filtros" }}
          </v-btn>

          <v-btn
            v-if="
              types_of_entries_ids.length > 0 ||
              users_ids.length > 0 ||
              provider_ids.length > 0 ||
              finance_client_ids.length > 0 ||
              finance_configuration_document_types_ids.length > 0 ||
              finance_configuration_payment_methods_ids.length > 0 ||
              finance_configuration_category_ids.length > 0 ||
              finance_configuration_profit_cost_center_ids.length > 0 ||
              finance_configuration_tag_ids.length > 0 ||
              cost_types_ids.length > 0 ||
              cost_appropriations_ids.length > 0
            "
            @click="handleCancelFilters"
            :disabled="loading"
            class="btn-clear-header"
          >
            <i class="fas fa-times mr-2"></i>
            {{ loading ? "..." : "Limpar" }}
          </v-btn>

          <v-btn
            v-if="!loading && (pay.length > 0 || receive.length > 0)"
            class="btn-print-header"
            @click="handlePrint"
          >
            <i class="fas fa-print mr-2"></i>
            Imprimir
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Controls Section -->
    <div class="controls-section">
      <div class="controls-card">
        <!-- Type Toggle -->
        <div class="type-toggle">
          <button
            :disabled="loading"
            :class="[
              'toggle-btn',
              cash_competence == 'cash' && 'toggle-btn-active',
            ]"
            @click="handleClickCashCompetence('cash')"
          >
            <i class="fas fa-cash-register mr-2"></i>
            {{ loading ? "..." : "Caixa" }}
          </button>
          <button
            :disabled="loading"
            :class="[
              'toggle-btn',
              cash_competence == 'competence' && 'toggle-btn-active',
            ]"
            @click="handleClickCashCompetence('competence')"
          >
            <i class="fas fa-calendar-check mr-2"></i>
            {{ loading ? "..." : "Competência" }}
          </button>
        </div>

        <!-- Date Controls -->
        <div class="date-controls">
          <div class="date-navigation">
            <button
              :disabled="loading"
              @click="handlePrevMonth"
              class="nav-btn prev-btn"
            >
              <i class="fas fa-chevron-left"></i>
            </button>

            <div class="date-input-wrapper">
              <input
                :disabled="loading"
                v-if="dayMonthYear == 'day'"
                v-model="month"
                type="date"
                class="date-input"
              />
              <input
                :disabled="loading"
                v-if="dayMonthYear == 'month'"
                v-model="month"
                type="month"
                class="date-input"
                @input="get"
              />
              <input
                :disabled="loading"
                v-if="dayMonthYear == 'year'"
                v-model="month"
                type="text"
                class="date-input"
                maxlength="4"
                minlength="4"
                placeholder="Ano"
                @input="handleInputMonthTypeYear($event.target.value)"
              />
            </div>

            <button
              :disabled="loading"
              @click="handleNextMonth"
              class="nav-btn next-btn"
            >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <div class="view-type-controls">
            <button
              :disabled="loading"
              :class="['view-btn', dayMonthYear == 'day' && 'view-btn-active']"
              @click="handleClickDayMonthYear('day')"
            >
              <i class="fas fa-calendar-day mr-1"></i>
              Dia
            </button>
            <button
              :disabled="loading"
              :class="[
                'view-btn',
                dayMonthYear == 'month' && 'view-btn-active',
              ]"
              @click="handleClickDayMonthYear('month')"
            >
              <i class="fas fa-calendar mr-1"></i>
              Mês
            </button>
            <button
              :disabled="loading"
              :class="['view-btn', dayMonthYear == 'year' && 'view-btn-active']"
              @click="handleClickDayMonthYear('year')"
            >
              <i class="fas fa-calendar-alt mr-1"></i>
              Ano
            </button>
          </div>

          <button
            :disabled="loading"
            @click="$bvModal.show('period')"
            class="period-btn"
          >
            <i class="fas fa-calendar-alt mr-2"></i>
            Período
          </button>
        </div>
      </div>
    </div>

    <!-- Content Section -->
    <div class="content-section">
      <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
        <!-- Results Grid -->
        <div v-if="!loading && (pay.length > 0 || receive.length > 0)">
          <!-- Summary Cards -->
          <div class="summary-cards">
            <div class="summary-card revenue-card">
              <div class="card-icon">
                <i class="fas fa-arrow-up"></i>
              </div>
              <div class="card-content">
                <div class="card-label">Receitas</div>
                <div class="card-value positive">
                  {{ formatMoney(String(total_receive)) }}
                </div>
              </div>
            </div>

            <div class="summary-card expense-card">
              <div class="card-icon">
                <i class="fas fa-arrow-down"></i>
              </div>
              <div class="card-content">
                <div class="card-label">Despesas</div>
                <div class="card-value negative">
                  {{ formatMoney(String(total_pay)) }}
                </div>
              </div>
            </div>

            <div
              class="summary-card result-card"
              :class="
                period_result >= 0 ? 'result-positive' : 'result-negative'
              "
            >
              <div class="card-icon">
                <i
                  :class="[
                    'fas',
                    period_result >= 0 ? 'fa-check-circle' : 'fa-times-circle',
                  ]"
                ></i>
              </div>
              <div class="card-content">
                <div class="card-label">Resultado</div>
                <div
                  class="card-value"
                  :class="period_result >= 0 ? 'positive' : 'negative'"
                >
                  {{ formatMoney(String(period_result)) }}
                </div>
              </div>
            </div>
          </div>

          <!-- Charts Section -->
          <div class="charts-section">
            <!-- Revenues Chart -->
            <div v-if="receive.length > 0" class="chart-card">
              <div class="chart-header">
                <h3 class="chart-title">
                  <i class="fas fa-arrow-up chart-icon revenue-icon"></i>
                  Receitas por Centro
                </h3>
              </div>
              <div class="chart-content">
                <div class="chart-wrapper">
                  <GChart
                    :settings="{ packages: ['corechart'] }"
                    type="PieChart"
                    :data="dataReceive"
                    :options="chartOptionsReceive"
                  />
                </div>
              </div>
            </div>

            <!-- Expenses Chart -->
            <div v-if="pay.length > 0" class="chart-card">
              <div class="chart-header">
                <h3 class="chart-title">
                  <i class="fas fa-arrow-down chart-icon expense-icon"></i>
                  Despesas por Centro
                </h3>
              </div>
              <div class="chart-content">
                <div class="chart-wrapper">
                  <GChart
                    :settings="{ packages: ['corechart'] }"
                    type="PieChart"
                    :data="dataPay"
                    :options="chartOptionsPay"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Details Section -->
          <div class="details-section">
            <!-- Revenues Details -->
            <div v-if="receive.length > 0" class="details-card">
              <div class="details-header">
                <h3 class="details-title">
                  <i class="fas fa-list-ul mr-2"></i>
                  Detalhamento de Receitas
                </h3>
              </div>
              <div class="details-content">
                <div
                  v-for="(item, key) in receive"
                  :key="key"
                  class="detail-item"
                >
                  <div class="detail-info">
                    <div class="detail-name">{{ item.description }}</div>
                    <div class="detail-bar-container">
                      <div
                        class="detail-bar revenue-bar"
                        :style="{
                          width:
                            (parseFloat(item.total) / max_progress) * 100 + '%',
                        }"
                      ></div>
                    </div>
                  </div>
                  <div class="detail-stats">
                    <div class="detail-value positive">
                      {{ formatMoney(String(item.total)) }}
                    </div>
                    <div class="detail-percentage">{{ item.percentage }}%</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Expenses Details -->
            <div v-if="pay.length > 0" class="details-card">
              <div class="details-header">
                <h3 class="details-title">
                  <i class="fas fa-list-ul mr-2"></i>
                  Detalhamento de Despesas
                </h3>
              </div>
              <div class="details-content">
                <div v-for="(item, key) in pay" :key="key" class="detail-item">
                  <div class="detail-info">
                    <div class="detail-name">{{ item.description }}</div>
                    <div class="detail-bar-container">
                      <div
                        class="detail-bar expense-bar"
                        :style="{
                          width:
                            (parseFloat(item.total) / max_progress) * 100 + '%',
                        }"
                      ></div>
                    </div>
                  </div>
                  <div class="detail-stats">
                    <div class="detail-value negative">
                      {{ formatMoney(String(item.total)) }}
                    </div>
                    <div class="detail-percentage">{{ item.percentage }}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- No Results -->
        <div
          v-if="!loading && pay.length == 0 && receive.length == 0"
          class="no-results"
        >
          <i class="fas fa-chart-pie no-results-icon"></i>
          <h3 class="no-results-title">Nenhum resultado encontrado</h3>
          <p class="no-results-text">
            Ajuste os filtros para visualizar os lançamentos
          </p>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";

import ErrorsMessages from "../../Components/ErrorsMessages";

import Filters from "../Releases/List/Filters";

import api from "../../../services/api";

import { formatMoney } from "../../../lib/format";

import moment from "moment";

import { getRestHomeSelectedFinancialAccount } from "../../../lib/functions";

export default {
  name: "ReleasesByProfitCostCenter",
  components: {
    GChart,
    ErrorsMessages,
    Filters,
  },
  data() {
    return {
      cash_competence: "cash",
      month: "",
      dayMonthYear: "month",
      account_ids: [],
      all_account: true,
      finance_configuration_account: [],
      users: [],
      users_ids: [],
      providers: [],
      provider_ids: [],
      finance_client: [],
      finance_client_ids: [],
      finance_configuration_document_types: [],
      finance_configuration_document_types_ids: [],
      finance_configuration_payment_methods: [],
      finance_configuration_payment_methods_ids: [],
      finance_configuration_category: [],
      finance_configuration_category_parents: [],
      finance_configuration_category_ids: [],
      finance_configuration_profit_cost_center: [],
      finance_configuration_profit_cost_center_ids: [],
      finance_configuration_tag: [],
      finance_configuration_tag_ids: [],
      cost_types: [],
      cost_types_ids: [],
      cost_appropriations: [],
      cost_appropriations_ids: [],
      types_of_entries_ids: [],
      filter_by_period: false,
      start_date: "",
      end_date: "",
      dataReceive: [["CATEGORIA", "QUANTIDADE"]],
      dataPay: [["CATEGORIA", "QUANTIDADE"]],
      pay: [],
      total_pay: 0,
      receive: [],
      total_receive: 0,
      max_progress: 0,
      period_result: 0,
      loading: false,
      errors: [],
    };
  },
  computed: {
    chartOptionsReceive() {
      return {
        pieHole: 0.4,
        height: 400,
        backgroundColor: "transparent",
        colors: [
          "#10b981",
          "#059669",
          "#34d399",
          "#6ee7b7",
          "#a7f3d0",
          "#d1fae5",
          "#047857",
          "#065f46",
          "#064e3b",
          "#022c22",
        ],
        legend: {
          position: "right",
          alignment: "center",
          textStyle: {
            color: "#374151",
            fontSize: 12,
            fontName: "WorkSans-Regular",
          },
        },
        chartArea: {
          left: 20,
          top: 20,
          width: "75%",
          height: "85%",
        },
        pieSliceTextStyle: {
          color: "white",
          fontSize: 11,
          fontName: "WorkSans-SemiBold",
        },
      };
    },
    chartOptionsPay() {
      return {
        pieHole: 0.4,
        height: 400,
        backgroundColor: "transparent",
        colors: [
          "#f59e0b",
          "#d97706",
          "#fbbf24",
          "#fcd34d",
          "#fde68a",
          "#fef3c7",
          "#b45309",
          "#92400e",
          "#78350f",
          "#451a03",
        ],
        legend: {
          position: "right",
          alignment: "center",
          textStyle: {
            color: "#374151",
            fontSize: 12,
            fontName: "WorkSans-Regular",
          },
        },
        chartArea: {
          left: 20,
          top: 20,
          width: "75%",
          height: "85%",
        },
        pieSliceTextStyle: {
          color: "white",
          fontSize: 11,
          fontName: "WorkSans-SemiBold",
        },
      };
    },
  },
  created() {
    this.month = moment().format("YYYY-MM");
    this.retrieve();
  },
  methods: {
    getRestHomeSelectedFinancialAccount,
    formatMoney,
    async retrieve() {
      if (this.errors.length == 0) await this.users_all();
      if (this.errors.length == 0) await this.financeConfigurationAccount();
      if (this.errors.length == 0) await this.provider();
      if (this.errors.length == 0) await this.financeClient();
      if (this.errors.length == 0)
        await this.financeConfigurationPaymentMethods();
      if (this.errors.length == 0)
        await this.financeConfigurationDocumentTypes();
      if (this.errors.length == 0) await this.financeConfigurationCategory();
      if (this.errors.length == 0)
        await this.financeConfigurationProfitCostCenter();
      if (this.errors.length == 0) await this.financeConfigurationTag();
      if (this.errors.length == 0) await this.costTypes();
      if (this.errors.length == 0) await this.costAppropriations();
      if (this.errors.length == 0) await this.get();
    },
    handleCancelFilterByPeriod() {
      this.filter_by_period = false;
      this.start_date = "";
      this.end_date = "";
      this.$bvModal.hide("period");
      this.get();
    },
    handleFilterByPeriod() {
      this.filter_by_period = true;
      this.get();
    },
    handlePrint() {
      window.print();
    },
    handlePrevMonth() {
      if (this.dayMonthYear == "day") {
        this.month = moment(this.month).subtract(1, "day").format("YYYY-MM-DD");
      }
      if (this.dayMonthYear == "month") {
        this.month = moment(this.month).subtract(1, "month").format("YYYY-MM");
      }
      if (this.dayMonthYear == "year") {
        this.month = String(parseFloat(this.month) - 1);
      }
      this.get();
    },
    handleNextMonth() {
      if (this.dayMonthYear == "day") {
        this.month = moment(this.month).add(1, "day").format("YYYY-MM-DD");
      }
      if (this.dayMonthYear == "month") {
        this.month = moment(this.month).add(1, "month").format("YYYY-MM");
      }
      if (this.dayMonthYear == "year") {
        this.month = String(parseFloat(this.month) + 1);
      }
      this.get();
    },
    handleInputMonthTypeYear(value) {
      if (value.length == 4) {
        this.get();
      }
    },
    handleClickDayMonthYear(type) {
      this.dayMonthYear = type;
      if (type == "day") {
        this.month = moment().format("YYYY-MM-DD");
      }
      if (type == "month") {
        this.month = moment().format("YYYY-MM");
      }
      if (type == "year") {
        this.month = moment().format("YYYY");
      }
      this.get();
    },
    handleClickCashCompetence(type) {
      this.cash_competence = type;
      this.get();
    },
    handleAllAccount(checked) {
      if (checked) {
        this.account_ids = [];
        for (let item of this.finance_configuration_account) {
          this.account_ids.push(item.id);
        }
      } else {
        this.account_ids = [];
      }
    },
    handleAccount() {
      if (
        this.account_ids.length == this.finance_configuration_account.length
      ) {
        this.all_account = true;
      } else {
        this.all_account = false;
      }
    },
    handleSuccessFilters(data) {
      this.types_of_entries_ids = data.types_of_entries_ids;
      this.users_ids = data.users_ids;
      this.provider_ids = data.provider_ids;
      this.finance_client_ids = data.finance_client_ids;
      this.finance_configuration_document_types_ids =
        data.finance_configuration_document_types_ids;
      this.finance_configuration_payment_methods_ids =
        data.finance_configuration_payment_methods_ids;
      this.finance_configuration_category_ids =
        data.finance_configuration_category_ids;
      this.finance_configuration_profit_cost_center_ids =
        data.finance_configuration_profit_cost_center_ids;
      this.finance_configuration_tag_ids = data.finance_configuration_tag_ids;
      this.cost_types_ids = data.cost_types_ids;
      this.cost_appropriations_ids = data.cost_appropriations_ids;
      this.$bvModal.hide("filters");
      this.get();
    },
    handleCancelFilters() {
      this.types_of_entries_ids = [];
      this.users_ids = [];
      this.provider_ids = [];
      this.finance_client_ids = [];
      this.finance_configuration_document_types_ids = [];
      this.finance_configuration_payment_methods_ids = [];
      this.finance_configuration_category_ids = [];
      this.finance_configuration_profit_cost_center_ids = [];
      this.finance_configuration_tag_ids = [];
      this.cost_types_ids = [];
      this.cost_appropriations_ids = [];
      this.get();
    },
    async users_all() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get("/rest-home/users-actives", {
          params,
        });

        const { users } = response.data;

        this.users = users;
      } catch (error) {
        console.log(error);
      }
    },
    async costTypes() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/cost-type-actives"
        );
        const { data } = response.data;
        this.cost_types = data;
      } catch (error) {
        console.log(error);
      }
    },
    async costAppropriations() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/cost-appropriation-actives"
        );
        const { data } = response.data;
        this.cost_appropriations = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationAccount() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/account-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        if (this.account_ids.length == 0) {
          for (let item of data) {
            this.account_ids.push(item.id);
          }
        }

        this.finance_configuration_account = data;
      } catch (error) {
        console.log(error);
      }
    },
    async provider() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        const params = { rest_home_id_selected_financial_account, active: 1 };

        const response = await api.get("/rest-home/providers", {
          params,
        });

        const { providers } = response.data;

        this.providers = providers;
      } catch (error) {
        console.log(error);
      }
    },
    async financeClient() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get("/rest-home/financial/client-actives", {
          params,
        });

        const { data } = response.data;

        this.finance_client = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationPaymentMethods() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/payment-methods-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_payment_methods = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationDocumentTypes() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/document-types-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_document_types = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationCategory() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/category-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        let parents = [];
        let daughters = [];
        for (let item of data) {
          if (item.type == "parent") {
            parents.push(item);
          } else {
            daughters.push(item);
          }
        }

        for (let parent of parents) {
          parent.items = [];
          for (let daughter of daughters) {
            if (daughter.finance_configuration_category_id == parent.id) {
              parent.items.push(daughter);
            }
          }
        }

        this.finance_configuration_category_parents = parents;
        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationProfitCostCenter() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/profit-cost-center-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_profit_cost_center = data;
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationTag() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/tags-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_tag = data;
      } catch (error) {
        console.log(error);
      }
    },
    async get() {
      try {
        this.loading = true;

        this.dataReceive = [["CATEGORIA", "QUANTIDADE"]];
        this.dataPay = [["CATEGORIA", "QUANTIDADE"]];

        let {
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
        } = this;

        let params = {
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
        };

        const response = await api.get(
          "/rest-home/financial/reports/releases-by-profit-cost-center",
          { params }
        );

        const { error, errors, pay, total_pay, receive, total_receive } =
          response.data;

        if (error) {
          this.errors = errors;
          this.receive = [];
          this.total_receive = 0;
          this.pay = [];
          this.total_pay = 0;
          this.max_progress = 0;
          this.period_result = 0;
        } else {
          this.errors = [];
          let pays = [];
          let receives = [];

          for (let item of receive) {
            if (item.total > 0) {
              let total = item.total;
              let init = String(total).substr(0, String(total).length - 2);
              let end = String(total).substr(String(total).length - 2, 2);
              this.dataReceive.push([
                item.description,
                parseFloat(`${init}.${end}`),
              ]);
              let percentage = (item.total * 100) / total_receive;
              percentage = percentage.toFixed(2);
              receives.push({ ...item, percentage });
            }
          }

          for (let item of pay) {
            if (item.total > 0) {
              let total = item.total;
              let init = String(total).substr(0, String(total).length - 2);
              let end = String(total).substr(String(total).length - 2, 2);
              this.dataPay.push([
                item.description,
                parseFloat(`${init}.${end}`),
              ]);
              let percentage = (item.total * 100) / total_pay;
              percentage = percentage.toFixed(2);
              pays.push({ ...item, percentage });
            }
          }

          this.receive = receives;
          this.total_receive = total_receive;
          this.pay = pays;
          this.total_pay = total_pay;

          if (parseFloat(total_pay) >= parseFloat(total_receive)) {
            this.max_progress = total_pay;
          } else {
            this.max_progress = total_receive;
          }

          this.period_result =
            parseFloat(total_receive) - parseFloat(total_pay);

          this.$bvModal.hide("account");
          this.$bvModal.hide("period");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.releases-profit-cost-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 24px;
}

/* Header Section */
.page-header {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 24px;
  margin-bottom: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}

.title-section {
  flex: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
  font-size: 24px;
}

.page-subtitle {
  color: #64748b;
  margin: 0;
  font-size: 14px;
}

.actions-section {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.btn-filter-header,
.btn-clear-header,
.btn-print-header {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 13px !important;
  padding: 10px 16px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
}

.btn-filter-header {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
}

.btn-clear-header {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
}

.btn-print-header {
  background: linear-gradient(135deg, #1f5a76 0%, #0f4c75 100%) !important;
  color: white !important;
  border: none !important;
}

.btn-filter-header:hover,
.btn-clear-header:hover,
.btn-print-header:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Controls Section */
.controls-section {
  margin-bottom: 24px;
}

.controls-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.type-toggle {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.toggle-btn {
  flex: 1;
  padding: 12px 20px;
  background: #f8fafc;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.toggle-btn:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.toggle-btn-active {
  background: linear-gradient(135deg, #1f5a76 0%, #0f4c75 100%);
  border-color: #1f5a76;
  color: white;
}

.toggle-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.date-controls {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.date-navigation {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 300px;
}

.nav-btn {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.3);
}

.nav-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.date-input-wrapper {
  flex: 1;
}

.date-input {
  width: 100%;
  padding: 10px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  transition: all 0.3s ease;
  font-family: "WorkSans-Regular", sans-serif;
}

.date-input:focus {
  outline: none;
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.date-input:disabled {
  background: #f8fafc;
  cursor: not-allowed;
}

.view-type-controls {
  display: flex;
  gap: 4px;
  background: #f8fafc;
  padding: 4px;
  border-radius: 8px;
}

.view-btn {
  padding: 8px 16px;
  background: transparent;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.view-btn:hover {
  background: #f1f5f9;
  color: #1e293b;
}

.view-btn-active {
  background: white;
  color: #0f65b0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.view-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.period-btn {
  padding: 10px 20px;
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%);
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.period-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(78, 145, 48, 0.3);
}

.period-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Content Section */
.content-section {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.loading-overlay {
  min-height: 400px;
  border-radius: 16px;
}

/* Summary Cards */
.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.summary-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.revenue-card {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border-color: #86efac;
}

.expense-card {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  border-color: #fbbf24;
}

.result-card.result-positive {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  border-color: #93c5fd;
}

.result-card.result-negative {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  border-color: #fca5a5;
}

.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.revenue-card .card-icon {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.expense-card .card-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.result-positive .card-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.result-negative .card-icon {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.card-content {
  flex: 1;
}

.card-label {
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-value {
  font-size: 24px;
  font-weight: 700;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.card-value.positive {
  color: #059669;
}

.card-value.negative {
  color: #d97706;
}

/* Charts Section */
.charts-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.chart-card {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.chart-header {
  background: white;
  padding: 20px;
  border-bottom: 2px solid #e5e7eb;
}

.chart-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.chart-icon {
  margin-right: 8px;
  font-size: 16px;
}

.revenue-icon {
  color: #10b981;
}

.expense-icon {
  color: #f59e0b;
}

.chart-content {
  padding: 20px;
}

.chart-wrapper {
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* Details Section */
.details-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 24px;
}

.details-card {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.details-header {
  background: white;
  padding: 20px;
  border-bottom: 2px solid #e5e7eb;
}

.details-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.details-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.detail-item:hover {
  border-color: #cbd5e1;
  transform: translateX(4px);
}

.detail-info {
  flex: 1;
  min-width: 0;
}

.detail-name {
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
  margin-bottom: 8px;
  word-break: break-word;
}

.detail-bar-container {
  width: 100%;
  height: 8px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
}

.detail-bar {
  height: 100%;
  border-radius: 4px;
  transition: width 0.8s ease;
}

.revenue-bar {
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
}

.expense-bar {
  background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);
}

.detail-stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.detail-value {
  font-size: 18px;
  font-weight: 700;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.detail-percentage {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 12px;
}

/* No Results */
.no-results {
  text-align: center;
  padding: 80px 24px;
}

.no-results-icon {
  font-size: 64px;
  color: #cbd5e1;
  margin-bottom: 20px;
}

.no-results-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.no-results-text {
  font-size: 16px;
  color: #64748b;
  margin: 0;
}

/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.modern-form-input {
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  transition: all 0.3s ease;
  font-family: "WorkSans-Regular", sans-serif;
}

.modern-form-input:focus {
  outline: none;
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.accounts-section {
  margin-bottom: 20px;
  padding: 20px;
}

.select-all-checkbox {
  padding: 20px;
  background: #f8fafc;
  border-radius: 8px;
  margin-bottom: 12px;
}

.accounts-list {
  max-height: 300px;
  overflow-y: auto;
  padding: 20px;
  background: #f8fafc;
  border-radius: 8px;
}

.account-checkbox {
  padding: 20px;
  margin-bottom: 4px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.account-checkbox:hover {
  background: #f1f5f9;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.btn-cancel-modern,
.btn-filter-modern {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  padding: 12px 24px !important;
  transition: all 0.3s ease !important;
}

.btn-cancel-modern {
  background: transparent !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
}

.btn-cancel-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
}

.btn-filter-modern {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.3) !important;
}

.btn-filter-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .charts-section,
  .details-section {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .releases-profit-cost-modern {
    padding: 16px;
  }

  .header-content {
    flex-direction: column;
    align-items: stretch;
  }

  .actions-section {
    justify-content: stretch;
  }

  .actions-section > * {
    flex: 1;
  }

  .page-title {
    font-size: 22px;
  }

  .date-controls {
    flex-direction: column;
  }

  .date-navigation {
    min-width: 100%;
  }

  .view-type-controls {
    width: 100%;
  }

  .view-btn {
    flex: 1;
  }

  .period-btn {
    width: 100%;
  }

  .summary-cards {
    grid-template-columns: 1fr;
  }

  .charts-section {
    grid-template-columns: 1fr;
  }

  .details-section {
    grid-template-columns: 1fr;
  }

  .detail-item {
    flex-direction: column;
    align-items: stretch;
  }

  .detail-stats {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 18px;
  }

  .title-icon {
    font-size: 20px;
  }

  .page-subtitle {
    font-size: 13px;
  }

  .card-value {
    font-size: 20px;
  }

  .detail-value {
    font-size: 16px;
  }

  .type-toggle {
    flex-direction: column;
  }
}

/* Print Styles */
@media print {
  .page-header,
  .controls-section {
    display: none !important;
  }

  .releases-profit-cost-modern {
    background: white;
    padding: 0;
  }

  .content-section {
    box-shadow: none;
    border: none;
  }
}

/* Override Bootstrap Vue Modal */
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid #e5e7eb;
  border-radius: 0;
}

.modern-modal >>> .modal-body {
  padding: 24px;
}

/* Custom Scrollbar */
.accounts-list::-webkit-scrollbar {
  width: 6px;
}

.accounts-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.accounts-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.accounts-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>